import React, { useEffect, useState } from 'react'

import { Select } from '../../../../module'
import { type InputRule } from './validationService'

type TypeProps = {
  validationRules: InputRule
  initialValue: string | number | unknown
  callbackValue: (value: string | number) => void
  header: string
}
type TypeSelect = {
  label: string
  name: string
}
const EditCellSelect = ({
  validationRules,
  initialValue,
  callbackValue,
  header,
}: TypeProps) => {
  const [dropdownOptions, setDropdownOptions] = useState<
    { label: string; name: string }[]
  >([])

  const [activeSelect, setActiveSelect] = useState<TypeSelect>({
    label: '',
    name: '',
  })

  useEffect(() => {
    const selectOptions: TypeSelect[] = []
    const options = validationRules?.options
    const isArrayOption = Array.isArray(options)
    if (isArrayOption) {
      options?.map((list) => {
        return selectOptions.push({
          label: list,
          name: list,
        })
      })
    } else {
      Object.entries(options as any).forEach(([key, value]: any) => {
        selectOptions.push({
          label: value,
          name: key,
        })
      })
    }

    setDropdownOptions(selectOptions)
    if (initialValue) {
      const activeOption = selectOptions.find(
        (item) => item.name === initialValue,
      )
      setActiveSelect(
        activeOption
          ? activeOption
          : {
              label: '',
              name: '',
            },
      )
    }
  }, [initialValue, validationRules?.data_type, validationRules?.options])

  return (
    <Select
      labelProps={{ label: header }}
      options={dropdownOptions}
      selectedItem={activeSelect}
      optionKeyName='name'
      labelKeyName='label'
      onChange={(options) => {
        setActiveSelect(options)
        callbackValue(options?.name)
      }}
      noMenuPortal
    />
  )
}

export default EditCellSelect
